/**
 * @generated SignedSource<<4a6db1fae5f9381d01a0a600ce265f6e>>
 * @relayHash 3cdb3a6a8b96bc52ac4b900d82f49e49
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3cdb3a6a8b96bc52ac4b900d82f49e49

import type { ConcreteRequest } from 'relay-runtime';
export type PendingIssueSuggestionKind = "ASSIGNEE" | "CLOSE" | "FIELD" | "LABEL" | "TYPE" | "%future added value";
export type RejectPendingIssueSuggestionsInput = {
  actorId: string;
  clientMutationId?: string | null | undefined;
  issueId: string;
  suggestions: ReadonlyArray<PendingIssueSuggestionRef>;
};
export type PendingIssueSuggestionRef = {
  assigneeId?: string | null | undefined;
  issueFieldId?: string | null | undefined;
  issueTypeId?: string | null | undefined;
  kind: PendingIssueSuggestionKind;
  labelId?: string | null | undefined;
};
export type rejectPendingIssueSuggestionsMutation$variables = {
  input: RejectPendingIssueSuggestionsInput;
};
export type rejectPendingIssueSuggestionsMutation$data = {
  readonly rejectPendingIssueSuggestions: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type rejectPendingIssueSuggestionsMutation = {
  response: rejectPendingIssueSuggestionsMutation$data;
  variables: rejectPendingIssueSuggestionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RejectPendingIssueSuggestionsPayload",
    "kind": "LinkedField",
    "name": "rejectPendingIssueSuggestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rejectPendingIssueSuggestionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rejectPendingIssueSuggestionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3cdb3a6a8b96bc52ac4b900d82f49e49",
    "metadata": {},
    "name": "rejectPendingIssueSuggestionsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "575b2af4116f732f9fab3311d01e330a";

export default node;
